namespace advisorop.components.widgets {

    enum Asset {
        Core,
        Alternative
    }
    
    export class GaugeBulbAllocationCoreAlternativeController{
        asOfDate;
        alternativeValue;
        coreValue;
        rtgName: string;    
        alternativeGauge;
        coreGauge;
        baseRadius: number = 90;

        updateGauge() {
            this.coreGauge = {
                "chart": {
                    "theme": "fint",
                    "baseFontSize": "14",
                    "caption": "Core Assets",
                    "captionPadding": 5,
                    "gaugeRadius": this.gaugeRadius(Asset.Core),
                    "showValue": 1,
                    "autoScale": 0,
                    "manageResize": 0,
                    "placeValuesInside": this.gaugeRadius(Asset.Core) > 22.5 ? 1 : 0,
                    "origW": this.baseRadius * 2,
                    "origH": this.baseRadius * 2,
                    "numberSuffix": "%",
                },
                "colorRange": {
                    "color": [
                        {
                            //"code": "#ff9933",
                            "code": "#6497b1",
                        }]
                },
                "value": this.coreValue,
            };
            this.alternativeGauge = {
                "chart": {
                    "theme": "fint",
                    "baseFontSize": "14",
                    "caption": "Alternative Assets",
                    "captionPadding": 5,
                    "gaugeRadius": this.gaugeRadius(Asset.Alternative),
                    "showValue": 1,
                    "autoScale": 0,
                    "manageResize": 0,
                    "placeValuesInside": this.gaugeRadius(Asset.Alternative) > 22.5 ? 1 : 0,
                    "origW": this.baseRadius * 2,
                    "origH": this.baseRadius * 2,
                    "numberSuffix": "%",
                },
                "colorRange": {
                    "color": [
                        {
                            //"code": "#ffbf80",
                            "code": "#b3cde0",
                        }]
                },
                "value": this.alternativeValue,
            };
        };

        gaugeRadius(forAsset: Asset): number {
            switch (forAsset) {
                case Asset.Core:
                    return Math.sqrt(this.baseRadius * this.baseRadius * this.coreValue / 100);
                case Asset.Alternative:
                    return Math.sqrt(this.baseRadius * this.baseRadius * this.alternativeValue / 100);
                default:
                    return this.baseRadius;
            }
    }
        
        constructor(private advisorService: services.AdvisorService) {
                                
        }
      

        $onChanges(evt) {
            for (var key in evt) {
                if (key === "alternativeValue" && this.alternativeValue >= 0) {
                    //console.log("Updating gauge to:" + this.alternativeValue);
                    this.coreValue = Math.round((100 - this.alternativeValue) * 100) / 100;
                    this.updateGauge();
                }
            }
        }

        $onInit(): void {
            if (this.alternativeValue == undefined) {
                this.alternativeValue = 0;
            }
            this.updateGauge();            
        }

        $routerOnActivate(next, previous) {
            
        }        

    }



    class GaugeBulbAllocationCoreAlternative implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        
        constructor() {
            this.bindings = {
                alternativeValue: "<",
                rtgName: "<"
            };
            this.controller = ["advisorService", GaugeBulbAllocationCoreAlternativeController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/gauge-bulb-allocation-core-alternative.html';            
        }
    }
    angular.module(Constants.APP).component("gaugeBulbAllocationCoreAlternative", new GaugeBulbAllocationCoreAlternative());
    
}